module.exports = __webpack_public_path__ + "static/img/logo.ee0fe8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/LandingPage/logo.png
// module id = aOfw
// module chunks = 12